module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-transfer-delegation"
  }, [_c('h2', [_vm._v("签署转让委托")]), _c('el-form', {
    ref: "form",
    staticClass: "ui form",
    attrs: {
      "model": _vm.form
    }
  }, [_c('div', {
    staticClass: "equal width fields"
  }, [_c('el-form-item', {
    staticClass: "ui field disabled"
  }, [_c('label', [_vm._v("押金")]), _c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.deposit_money),
      callback: function($$v) {
        _vm.deposit_money = $$v
      },
      expression: "deposit_money"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field required"
  }, [_c('label', [_vm._v("转让手续费")]), _c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.form.delegation_fee),
      callback: function($$v) {
        _vm.$set(_vm.form, "delegation_fee", $$v)
      },
      expression: "form.delegation_fee"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field disabled"
  }, [_c('label', [_vm._v("可用金额")]), _c('el-input', {
    attrs: {
      "value": _vm.deposit_money - _vm.form.delegation_fee,
      "type": "text"
    }
  })], 1)], 1), _c('div', {
    staticClass: "equal width fields"
  }, [_c('el-form-item', {
    staticClass: "ui field disabled"
  }, [_c('label', [_vm._v("租金 / 月")]), _c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.price_month),
      callback: function($$v) {
        _vm.price_month = $$v
      },
      expression: "price_month"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field disabled"
  }, [_c('label', [_vm._v("管理费 / 月")]), _c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.management_fee_month),
      callback: function($$v) {
        _vm.management_fee_month = $$v
      },
      expression: "management_fee_month"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field required"
  }, [_c('label', [_vm._v("日租金 (" + _vm._s(_vm.average_price_day) + ")")]), _c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.form.price_day),
      callback: function($$v) {
        _vm.$set(_vm.form, "price_day", $$v)
      },
      expression: "form.price_day"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field disabled"
  }, [_c('label', [_vm._v("委托天数(+" + _vm._s(_vm.extra_delegation_days) + ")")]), _c('el-input', {
    attrs: {
      "value": _vm.delegation_days,
      "type": "text"
    }
  })], 1)], 1), _c('div', {
    staticClass: "equal width fields"
  }, [_c('el-form-item', {
    staticClass: "ui field required"
  }, [_c('label', [_vm._v("委托开始日期")]), _c('datepicker', {
    attrs: {
      "type": "date",
      "placeholder": "开始日期"
    },
    model: {
      value: (_vm.form.date_start),
      callback: function($$v) {
        _vm.$set(_vm.form, "date_start", $$v)
      },
      expression: "form.date_start"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field disabled"
  }, [_c('label', [_vm._v("委托结束日期")]), _c('datepicker', {
    attrs: {
      "value": _vm.date_end,
      "type": "date",
      "placeholder": "结束日期"
    }
  })], 1)], 1), _c('h3', [_vm._v("委托人信息")]), _c('div', {
    staticClass: "equal width fields"
  }, [_c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "customer_name"
    }
  }, [_c('label', [_vm._v("姓名")]), _c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.form.customer_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "customer_name", $$v)
      },
      expression: "form.customer_name"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "customer_phone"
    }
  }, [_c('label', [_vm._v("手机")]), _c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.form.customer_phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "customer_phone", $$v)
      },
      expression: "form.customer_phone"
    }
  })], 1)], 1), _c('h3', [_vm._v("备注")]), _c('el-form-item', {
    staticClass: "ui field",
    attrs: {
      "prop": "note"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.note),
      expression: "form.note"
    }],
    attrs: {
      "rows": "2"
    },
    domProps: {
      "value": (_vm.form.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "note", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "ui field actions"
  }, [_c('div', {
    staticClass: "ui button themed icon labeled",
    on: {
      "click": _vm.finish
    }
  }, [_c('i', {
    staticClass: "icon checkmark"
  }), _vm._v("确认签署")]), _c('div', {
    staticClass: "ui button",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-660b3358","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/forms/FormTransferDelegation.vue
// module id = 413
// module chunks = 0